<template>
  <div>
    <ots-main-title></ots-main-title>
    <div class="systemBox">
      <!-- 基本设置部分 -->
      <div class="section">
        <h1>基本设置</h1>
        <template v-for="item in basicsSetList" >
          <!--  v-if="!item.isHide"  -->
          <div :key="item.title" class="setState" v-if="isShowList[item.prop] == '1'">
            <span>{{ item.title }}</span>
            <!-- (1) 基本设置 switch 选项 -->
            <el-switch
              v-model="basicsMap[item.prop]"
              :active-value="1"
              :inactive-value="0"
              @input="$forceUpdate()"
            ></el-switch>
            <!-- (2) 基本设置(是否使用鹰眼监控) -->
            <p
              class="numExplit"
              v-if="item.prop == 'needMonitor' && basicsMap['needMonitor'] == 1"
            >
              <!-- <a href="javascript:void(0);" @click="getMonitor">下载活动安排数据</a>，（下载后，导入OTS<a>&nbsp;活动安排&nbsp;</a>功能中。） -->
            </p>
            <!-- <p  class="numExplit" v-if="item.prop == 'needOIS'  && basicsMap['needOIS'] == 1" ></p> -->
            <!-- (3) 基本设置(设置考试状态权限) -->
            <p class="numExplit" v-if="item.prop == 'examStateJurisdiction'">
              机考验证审核功能，审核时是否开通设置考试状态权限，取自该设置。
              （考试状态设置异常，分数为0。设置为正常，分数为实际试卷分数。）
            </p>
            <p class="numExplit" v-if="item.prop == 'showExamCheckState'">
              学生成绩查询考试状态展示，例如违纪，作弊等状态
            </p>
          </div>

        </template>
       
        <div class="personalCheck" v-if="isShowList.examScreenOpenTimeSwitch == '1'">
          <span>考中大屏提前开放时间</span>
          <el-select v-model="basicsMap.examScreenOpenTimeSwitch" placeholder="请选择">
            <el-option
              v-for="item in dataV_Time"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <i>分钟</i>
        </div>

        <!-- <div class="personalCheck" v-if="isShowList.uploadTimes == '1'">
          <span>考生人身核验最多</span>
          <el-input
            v-model.number="basicsMap['uploadTimes']"
            placeholder="请输入"
            @blur="uploadTimeBlur"
          ></el-input
          ><em>次</em>
          <p class="numExplit">
            考生上传照片时会和公安部身份证照片进行比对，确认照片是考生本人，如果确认有近照和身份证照片差别巨大的，由老师人工核验。
          </p>
        </div> -->
        
        <div class="personalCheck" v-if="isShowList.allowTempPassword == '1'">
          <span>使用临时密码</span>
          <el-switch
              v-model="basicsMap.allowTempPassword"
              :active-value="1"
              :inactive-value="0"
            ></el-switch>
            <p class="numExplit">
              （开启后允许证件号后六位登录，只允许在当场次的考试时间内）
            </p>
        </div>
       
        <div class="personalCheck" v-if="basicsMap.allowTempPassword === 1 && isShowList.allowTempPassword == '1'">
          <span>临时密码允许登录时间</span>
          <el-select
            v-model="basicsMap.allowTempPasswordMinutes"
            placeholder="请选择"
          >
            <el-option
              v-for="item in allowTempPasswordMinutes"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <i>分钟</i>
        </div>

        <div class="personalCheck" v-if="isShowList.needExamOrderCode == '1'">
          <span>使用考试口令</span>
          <el-switch
              v-model="basicsMap.needExamOrderCode"
              :active-value="1"
              :inactive-value="0"
            ></el-switch>
            <p class="numExplit">
              (开启后进入考试活动前需要验证考试口令，考试口令正确后可以进入考试)
            </p>
        </div>

        <div class="personalCheck" v-if="basicsMap.needExamOrderCode === 1 && isShowList.needExamOrderCode == '1'">
          <span>考试口令考前查看时间</span>
          <el-select
            v-model="basicsMap.showExamOrderCodeMinutes"
            placeholder="请选择"
          >
            <el-option
              v-for="item in showExamOrderCodeMinutes"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <i>分钟</i>
        </div>
     
      </div>

      <!-- 缴费设置部分 -->
      <!-- 
      <div class="section mt20">
        <h1>缴费设置</h1>
        <div class="setState">
          <span>是否开启缴费</span>
          <el-radio-group class="df-ac pr">
            <el-switch v-model="basicsMap.needPayment" :active-value="1" :inactive-value="0"></el-switch>
          </el-radio-group>
        </div>
        <div class="setState" v-if="basicsMap.needPayment == 1">
          <span>缴费方式</span>
          <el-radio-group v-model="basicsMap.onlinePayment" class="df-ac pr">
            <el-radio-button label="1">线上缴费</el-radio-button>
            <el-tooltip content="报名学员通过系统自动生成的订单进行支付" placement="top">
              <i class="el-icon-question f18 col_grayQ cp"></i>
            </el-tooltip>
            <el-radio-button label="2" class="ml30">线下缴费</el-radio-button>
            <el-tooltip content="报名学员通过您上传的收款码、转账或现金等方式缴费" placement="top">
              <i class="el-icon-question f18 col_grayQ cp"></i>
            </el-tooltip>
          </el-radio-group>
        </div>
      </div>

      <div v-show="basicsMap.onlinePayment == 2">
        <div class="setState">
          <span>线下缴费二维码</span>
          <el-upload
            action=""
            class="avatar-uploader dbi"
            :show-file-list="false"
            :before-upload="beforeAvatarUpload"
            :http-request="uploadImg"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <i class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div class="avatarTip">
            <p class="mb10">温馨提示：</p>
            <p class="col_grayQ">1.请务必保证所上传二维码的准确性；</p>
            <p class="col_grayQ">
              2.二维码尺寸建议不小于300*300像素；支持jpg/png格式，大小不超过200KB；
            </p>
          </div>
        </div>
        <div class="setState">
          <span>缴费说明</span>
          <div>
            <el-input
              type="textarea"
              v-model="basicsMap.paymentText"
              placeholder="请添加缴费说明，以小写分号;分隔多条说明，可预览查看"
            ></el-input>
            <div class="mt10 col_blue cp pr preBtn dinb">
              预览
              <div class="codePreview col_black">
                <div class="picArea">
                  <img v-if="imageUrl" :src="imageUrl" alt="" />
                </div>
                <div class="payContent">
                  <p v-for="(item, index) in payRemarkList" :key="index">
                    {{ `${index + 1}.${item}` }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> 
      -->

      <!-- 学生平台报名(配置教学点标题名称) -->
      <div class="section mt20">
        <h1>学生平台报名</h1>
        <div class="setState" v-if="isShowList.stationName == '1'">
          <span>“教学点”标题名称</span>
          <el-input
            v-model="basicsMap.stationName"
            placeholder="请输入"
            @input="$forceUpdate()"
          ></el-input>
        </div>

        <div class="setState" >
          <span>报名是否开启短信验证</span>
          <el-switch v-model="basicsMap.smsCheckForSign" :active-value="1" :inactive-value="0"></el-switch>
        </div>



        <!-- <div class="setState">
          <span>是否开启照片标准化</span>
          <el-switch
            v-model="basicsMap['needStandardPhoto']"
            :active-value="1"
            :inactive-value="0"
          ></el-switch>
        </div> -->

        <!-- <div
          v-if="basicsMap['needStandardPhoto'] == 1"
          class="needStandardPhoto"
        >
          <p>背景颜色</p>
          <el-radio-group v-model="standardPhotoBgColor">
            <el-radio label="蓝色">蓝色</el-radio>
            <el-radio label="红色">红色</el-radio>
            <el-radio label="白色">白色</el-radio>
          </el-radio-group>
        </div> -->

        <!-- <div
          v-if="basicsMap['needStandardPhoto'] == 1"
          class="needStandardPhoto"
        >
          <p>尺寸大小</p>
          <el-radio-group v-model="standardPhotoSize">
            <el-radio label="一寸">一寸</el-radio>
            <el-radio label="大一寸">大一寸</el-radio>
            <el-radio label="小二寸">小二寸</el-radio>
            <el-radio label="二寸">二寸</el-radio>
            <el-radio label="大二寸">大二寸</el-radio>
          </el-radio-group>
        </div> -->

      </div>

      <!-- 固定字段,照片上传配置 -->
      <!-- <div class="section mt20" v-if="isShowList.stuImgCondition == '1'">
        <h1>学生照片上传要求</h1>
        <div class="setState">
          <span>照片说明</span>
          <el-input
            v-model="basicsMap.stuImgText"
            placeholder="请输入"
            @input="$forceUpdate()"
            type="textarea"
          ></el-input>
        </div>
        <div class="setState">
          <span>格式</span>
          <el-checkbox-group
            v-model="basicsMap['stuImgExtName']"
            class="df-ac pr"
            @input="$forceUpdate()"
          >
            <el-checkbox label="jpeg"></el-checkbox>
            <el-checkbox label="jpg"></el-checkbox>
            <el-checkbox label="png"></el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="personalCheck">
          <span>大小 ≤ </span>
          <el-input
            placeholder="请输入"
            v-model.number="basicsMap.stuImgMaxSize"
            @input="$forceUpdate()"
          ></el-input
          ><em>k</em>
        </div>
      </div> -->



      <!-- 配置 Ip 验证范围 -->
      <div class="section mt20">
        <h1>IP设置</h1>
        <div class="setState">
          <span>验证IP范围</span>
          <el-switch
            v-model="basicsMap['needIPCheck']"
            :active-value="1"
            :inactive-value="0"
          ></el-switch>
        </div>
        <div class="ipScope" v-if="basicsMap['needIPCheck'] === 1">
          <h6>IP范围设置</h6>
          <div
            v-for="(item, index) in ipSetLits"
            :key="item.id"
            class="inputBox"
          >
            <el-input v-model="item.ipBegin" placeholder="请输入"></el-input>
            <span> 至</span>
            <el-input v-model="item.ipEnd" placeholder="请输入"></el-input>
            <i
              v-if="index !== 0"
              class="el-icon-delete"
              @click="deletIp(item.id)"
            ></i>
          </div>
          <span class="addIp" @click="addIp">+ 增加IP范围</span>
        </div>
      </div>

      <!-- 密码设置 -->
      <div class="section mt20">
        <h1>密码设置</h1>

        <div class="personalCheck">
          <span>密码有效期</span>
          <el-select v-model="basicsMap.passWordValidityPeriod" placeholder="请选择">
            <el-option label="3" :value="3"></el-option>
            <el-option label="6" :value="6"></el-option>
            <el-option label="12" :value="12"></el-option>
          </el-select>
          <i>月</i>
        </div>

        <div class="personalCheck">
          <span>登录密码错误次数</span>
          <el-select v-model="basicsMap.passWordErrorTimes" placeholder="请选择">
            <el-option label="5" :value="5"></el-option>
            <el-option label="10" :value="10"></el-option>
          </el-select>
          <i>次</i>
        </div>

        <div class="personalCheck">
          <span>冻结时长（密码错误次数超过上限）</span>
          <el-select v-model="basicsMap.accountFreezeDuration" placeholder="请选择">
            <el-option label="2" :value="2"></el-option>
            <el-option label="10" :value="10"></el-option>
            <el-option label="20" :value="20"></el-option>
            <el-option label="30" :value="30"></el-option>
          </el-select>
          <i>分钟</i>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  name: "systemSet",
  data() {
    return {
      // 基本设置 switch 配置
      needExamOrdershow:true,
      needOISSignState: "false",
      basicsSetList: [
        {
          title: "设置考生范围",
          prop: "needRegion",
        },
        {
          title: "使用巡考系统",
          prop: "needOIS",
        },
        {
          title: "巡考签到验证",
          prop: "needOISSignState",
          isHide: true,
        },
        {
          title: "需要签到表",
          prop: "needSignTable",
        },
        {
          title: "是否下载合格证",
          prop: "needCertificatePrint",
        },
        {
          title: "使用鹰眼监控",
          prop: "needMonitor",
        },
        {
          title: "设置考试状态权限",
          prop: "examStateJurisdiction",
        },
        {
          title: "考试状态展示",
          prop: "showExamCheckState",
        },
        {
          title: "使用阅卷系统",
          prop: "needOMS"
        },
        // {
        //   title: "使用临时密码",
        //   prop: "allowTempPassword",
        // },
        // {
        //   title: "使用考试口令",
        //   prop: "needExamOrderCode",
        // },
      ],
      showExamOrderCodeMinutes: [
        {
          name: "1",
          id: "1",
        },
        {
          name: "5",
          id: "5",
        },
        {
          name: "10",
          id: "10",
        },
      ],

      dataV_Time: [
        {name: "0", id: "0"},
        {name: "15", id: "15"},
        {name: "30", id: "30"},
        {name: "45", id: "45"},
        {name: "60", id: "60"},
      ],

      allowTempPasswordMinutes: [
        {
          name: "1",
          id: "1",
        },
        {
          name: "5",
          id: "5",
        },
        {
          name: "10",
          id: "10",
        },
        {
          name: "15",
          id: "15",
        },
        {
          name: "20",
          id: "20",
        },
        {
          name: "25",
          id: "25",
        },
        {
          name: "30",
          id: "30",
        },
      ],
      // ip 范围设置
      ipSetLits: [
        {
          ipBegin: "",
          ipEnd: "",
        },
      ],
      // 系统设置表单参数
      basicsMap: {
        // 线上支付
        onlinePayment: 1,
        // 注意事项
        paymentText: "注意事项一;注意事项二",
        // 允许上传图片次数
        uploadTimes: 3,
        // 学生图片扩展名
        stuImgExtName: [],
        // OIS签名状态
        needOISSignState: 1,
        // 是否需要标准照片
        needStandardPhoto: 0,
        // 是否需要定额订单号
        needExamOrderCode: "",
        // 定额订单号显示时间
        showExamOrderCodeMinutes: "",
        // 临时密码允许登录时间
        allowTempPasswordMinutes: "",
        // 是否显示定额订单号
        examScreenOpenTimeSwitch: "0",
        // 临时密码
        allowTempPassword: "",
        // 定额订单号
        needExamOrderCode: "",
        // 密码有效期
        passWordValidityPeriod: "",
        // 登录密码错误次数
        passWordErrorTimes: "",
        // 密码错误次数超过上限后冻结时长
        accountFreezeDuration: "",
      },

      // 缴费二维码链接
      imageUrl: "",
      standardPhotoSize: "一寸",
      standardPhotoBgColor: "蓝色",

      // 控制所有元素显示
      isShowList: {},
    };
  },
  watch: {
    // 监听基本信息表中的需要OIS设置
    "basicsMap.needOIS": function (val) {
      if (val === 1) {
        // 如果需要OIS设置，则显示第三项设置
        this.$set(this.basicsSetList[2], "isHide", false);
      } else {
        // 否则隐藏第三项设置
        this.basicsMap.needOISSignState = 0;
        this.$set(this.basicsSetList[2], "isHide", true);
      }
    },
    // 监听基本信息表中的需要定额订单号设置
    "basicsMap.needExamOrderCode":function(val){
      if(val == 0){
        // 如果不需要定额订单号设置，则隐藏需要定额订单号选项
        this.needExamOrdershow = false
      }
    },
    // 监听基本信息表中的需要标准照片设置
    "basicsMap.needStandardPhoto": function (val) {
      if (val === 0) {
        // 如果不需要标准照片设置，则将设置设置为0
        this.needStandardPhoto = 0;
      }
    },
  },
  computed: {
    payRemarkList() {
      return this.basicsMap.paymentText
        ? this.basicsMap.paymentText.split(";")
        : null;
    },
  },
  methods: {
    ...mapMutations(["SAVE_PAGE_THIS"]),

    // 使用鹰眼监控,下载活动数据
    getMonitor() {
      this.$api.system.exportUserArrangement().then((res) => {
        if (res.data) {
          window.open(res.data);
        }
      });
    },

    // Ip 设置 -- 添加 Ip 地址
    addIp() {
      let ipItem = { ipBegin: "", ipEnd: "" };
      if (!this.ipSetLits[0].ipBegin || !this.ipSetLits[0].ipEnd) {
        this.$confirm("请设置完整的IP范围", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          roundButton: true,
        });
        return;
      }
      this.ipSetLits.push(ipItem);
    },

    // Ip 设置 -- 删除 Ip 地址
    deletIp(id) {
      const indexiplist = this.ipSetLits.findIndex((item) => item.id === id);
      if (indexiplist !== -1) {
        this.ipSetLits.splice(indexiplist, 1);
      }
    },

    // 设置人身审核次数
    uploadTimeBlur() {
      // 不为负数, 最少 0 次
      if (
        this.basicsMap["uploadTimes"] < 0 ||
        (!this.basicsMap["uploadTimes"] && this.basicsMap["uploadTimes"] != "0")
      ) {
        this.$message.warning("考生人身核验最少设置 0 次！");
        this.basicsMap["uploadTimes"] = 0;
        // 最多三次, 超出归为 1
      } else if (this.basicsMap["uploadTimes"] > 3) {
        this.$message.warning("考生人身核验最多设置 3 次！");
        this.basicsMap["uploadTimes"] = 3;
      }
    },

    // 获取系统配置
    getConfigData() {
      this.$api.system.getConfigData().then((res) => {

        // 缴费说明绑在了缴费方式上
        let basicsMap = {};
        let configList = res.data.configList;
        if (res.data.standardPhotoSize) {
          this.standardPhotoSize = res.data.standardPhotoSize;
        }
        if (res.data.standardPhotoBgColor) {
          this.standardPhotoBgColor = res.data.standardPhotoBgColor;
        }
        // 系统配置
        configList.forEach((item) => {
          basicsMap[item.setName] = item.setValue;

          if (item.setName == "onlinePayment" && item.setShowText) {
            basicsMap["paymentText"] = item.setShowText;
          } else if (item.setName == "stationName") {
            basicsMap["stationName"] = item.setValue2;
          } else if (item.setName == "stuImgCondition") {
            basicsMap["stuImgText"] = item.setShowText;
            item.setValue2.split(",");
            this.basicsMap["stuImgExtName"] = [];
            this.basicsMap["stuImgExtName"] = this.basicsMap[
              "stuImgExtName"
            ].concat(item.setValue2.split(","));
            basicsMap["stuImgMaxSize"] = item.setValue;
          }
        });
        // 获取 addBatch.vue 中传递的值.
        let payInfo = JSON.parse(localStorage.getItem("payInfo"));
        // 新增判断 ( 是否复制了上一批次缴费信息 )
        if (payInfo != null) {
          this.basicsMap = Object.assign(this.basicsMap, basicsMap);
          // 缴费方式
          this.basicsMap.onlinePayment = payInfo.onlinePayment;
          // 缴费说明
          this.basicsMap.paymentText = payInfo.paymentText;
          // 缴费二维码
          this.imageUrl = payInfo.imageUrl;
        } else {
          this.basicsMap = Object.assign(this.basicsMap, basicsMap);
          this.imageUrl = res.data.paymentPicture
            ? res.data.paymentPicture
            : "";
        }


        console.log(this.basicsMap)

        // 获取IP范围
        if (res.data.ipList.length > 0) {
          this.ipSetLits = res.data.ipList;
        } else {
          this.ipSetLits = [{ ipBegin: "", ipEnd: "" }];
        }

        // 2024年1月5日 ==> 控制所有属性的显示隐藏
        configList.map(e=>{
          this.isShowList[e.setName] = e.openFlag;
        })
        // configList.map( e => {
        //   this.basicsSetList.map(item => {
        //     if (e.setName == item.prop) {
        //       item.isHide = e.openFlag;
        //     }
        //   })
        // })
      });
    },

    // 缴费二维码上传格式, 大小验证
    beforeAvatarUpload(file) {
      const configType = ["png", "jpg", "jpeg"];
      const imageType = file.type.split("/")[1].toLowerCase();
      const pettern = /^image/;
      const isImg = pettern.test(file.type) && configType.includes(imageType);
      const isLimit = file.size / 1024 < 200;
      if (!isImg) {
        this.$message.error("上传图片只能是 JPG/PNG 格式!");
      }
      if (!isLimit) {
        this.$message.error("上传图片大小不能超过 200KB!");
      }
      return isImg && isLimit;
    },

    // 图片上传
    uploadImg(data) {
      let that = this;
      let fileData = data.file;
      let reader = new FileReader();
      reader.readAsDataURL(fileData);
      reader.onload = function (e) {
        if (this.result) {
          that.imageUrl = this.result;
          that.basicsMap.paymentPicture = this.result.split(",")[1];
          if (fileData.type) {
            that.basicsMap.picExtname = fileData.type.split("/")[1];
          }
        }
      };
    },

    // 保存 -- 系统设置
    save() {
      // 清除上传次数 -- 人身审核次数
      this.uploadTimeBlur();
      // 如果没有需要IP检查，则清空IP设置
      if (!this.basicsMap.needIPCheck) {
        this.ipSetLits = [{ ipStart: "", ipEnd: "" }];
      } else {
        // 如果IP设置不完整，提示用户设置完整的IP范围
        if (!this.ipSetLits[0].ipBegin || !this.ipSetLits[0].ipEnd) {
          this.$confirm("请设置完整的IP范围", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            roundButton: true,
          });
          return;
        }
      }
      // 查询参数处理
      this.basicsMap.stuImgExtName = this.basicsMap.stuImgExtName.join(",");
      this.basicsMap.standardPhotoSize = this.standardPhotoSize;
      this.basicsMap.standardPhotoBgColor = this.standardPhotoBgColor;
      // 拼接查询添加配置的参数
      let queryAddConfig = {
        ...this.basicsMap,
        ipJsonString: JSON.stringify(this.ipSetLits),
      };
      // 调用添加配置的API
      this.$api.system.addConfig(queryAddConfig).then((res) => {
        if (res.code) {
          // 如果添加成功，提示用户
          this.$message.success("保存成功！");
          // 获取配置数据
          this.getConfigData();
        }
      }).catch((err)=>{
        this.$message.error("保存失败，请重试！");
      })
    },
  },

  mounted() {
    this.SAVE_PAGE_THIS(this);
    this.getConfigData(); 
  },

  destroyed() {
    localStorage.removeItem("payInfo");
  },

  // 返回
  goBack() {
    this.$router.go(-1);
  },
};
</script>

<style lang="less" scoped>
.systemBox {
  background: #fff;
  padding: 20px 24px;
  border-radius: 8px !important;
  .section {
    padding-bottom: 30px;
    border-bottom: 1px solid #f1f2f5;
    h1 {
      color: #2d2f33;
      font-size: 16px;
      font-weight: 500;
      margin-bottom: 40px;
    }
    span {
      line-height: 35px;
    }
  }
  .basicCon {
    padding-bottom: 30px;
    border-bottom: 1px solid #f1f2f5;
  }
  h1 {
    color: #2d2f33;
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 40px;
  }
  .setState,
  .personalCheck {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 40px;
    p {
     
      a:first-child {
        text-decoration: underline;
      }
      a {
        color: #45494d;
      }
    }
    i{
      margin-left: 10px;
      font-style: normal;
    }
    span {
      display: block;
      width: 155px !important;
      color: #45494d;
      text-align: right;
      margin-right: 16px;
    }
    .el-input {
      width: 160px;
      height: 36px;
    }

    em {
      position: relative;
      margin-left: -25px;
      z-index: 1;
      font-style: normal;
    }
  }
  // .personalCheck {
  //   margin-bottom: 16px !important;
  // }
  .numExplit {
    font-size: 14px;
    color: #9299a6;
    margin-left: 15px;
  }
  .ipSetCon {
    padding-top: 32px;
  }
  .ipScope {
    padding: 24px 32px;
    box-sizing: border-box;
    margin-left: 160px;
    background: #f8f9fc;
    border-radius: 8px;
    h6 {
      color: #45494d;
      font-size: 14px;
      margin-bottom: 16px;
    }
    .inputBox {
      display: flex;
      height: 36px;
      line-height: 36px;
      justify-items: center;
      vertical-align: middle;
      margin-bottom: 8px;
      /deep/ .el-input {
        width: 240px;
        height: 36px;
        line-height: 36px;
      }
      span {
        margin: 0 11px;
      }
      i {
        margin: 12px 0 0 20px;
        color: #006aff;
      }
    }
    .addIp {
      color: #006aff;
      font-size: 14px;
    }
  }

  /deep/ .el-radio-button__inner {
    margin-right: 8px;
    color: #45494d !important;
    background: #f4f5f8 !important;
    font-size: 13px;
    border-radius: 4px !important;
    border: 1px solid #dadde6 !important;
    padding: 10px 20px;
  }
  /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    background: #ebf5ff !important;
    border: 1px solid #006aff !important;
    color: #006aff !important;
    box-shadow: none;
  }

  /deep/ .el-checkbox-button__inner {
    margin-right: 8px;
  }

  // /deep/ .el-checkbox-button__inner {
  //   margin-right: 8px;
  //   color: #45494d !important;
  //   background: #f4f5f8 !important;
  //   font-size: 13px;
  //   border-radius: 4px !important;
  //   border: 1px solid #dadde6 !important;
  //   padding: 10px 20px;
  // }
  // /deep/ .el-checkbox-button__orig-radio:checked + .el-checkbox-button__inner {
  //   background: #ebf5ff !important;
  //   border: 1px solid #006aff !important;
  //   color: #006aff !important;
  //   box-shadow: none;
  // }
}
.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 131px;
  height: 131px;
}
.avatar-uploader /deep/ .el-upload:hover {
  border-color: #006aff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 131px;
  height: 131px;
  line-height: 131px;
  text-align: center;
  position: absolute;
  top: 0%;
  left: 0%;
}
.avatar-uploader /deep/ .el-upload:hover .avatar-uploader-icon {
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 3;
}
.avatar /deep/ {
  width: 131px;
  height: 131px;
  position: absolute;
  top: 0%;
  left: 0%;
  z-index: 2;
}
.avatarTip {
  padding-top: 8px;
  display: inline-block;
  vertical-align: top;
  margin-left: 20px;
  line-height: 1.8;
}
/deep/ .el-textarea {
  width: 500px;
}
/deep/ .el-textarea__inner {
  width: 500px !important;
  height: 100px;
}
.preBtn:hover .codePreview {
  display: flex;
}
.codePreview {
  bottom: -60px;
  left: 40px;
  width: 405px;
  min-height: 487px;
  background: #ffffff;
  box-shadow: 0px 8px 32px 0px rgba(0, 0, 0, 0.12);
  border: 1px solid #dadde6;
  border-radius: 4px;
  position: absolute;
  display: none;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 32px;
  box-sizing: border-box;
  z-index: 2;
  .picArea {
    width: 280px;
    height: 280px;
    padding: 10px;
    box-sizing: border-box;
    margin: 20px auto;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .payContent {
    width: 100%;
    word-break: break-word;
  }
}
// /deep/ .el-switch {
//   margin-top: 8px;
// }
/* 2021/11/26 IE 表单样式问题(盒模型大小同谷歌有异) */
/deep/ .el-input .el-input__inner {
  width: 160px;
  height: 36px;
  line-height: 18px;
}
/deep/ .el-input {
  width: 160px !important;
}
.needStandardPhoto {
  display: flex;
  margin-bottom: 40px;
  p {
    margin: 10px 16px 10px 5px;
    width: 140px;
    text-align: right;
  }
  div {
    margin-top: 15px;
  }
}
/deep/ .el-popper {
  min-width: 160px !important;
}
/deep/ .el-select {
  width: 160px !important;
}
</style>
